import CryptoJS from "crypto-js";
import PageTracker from "../../../../common/PageTrackerHelper.js";
import VueElementLoading from "vue-element-loading";
import tableTemplate from "../../common/table-template";
import AllocationPopup from "../../CommonAllocation/b-modalsTemplate";
import pendingPods from '../../common/pendingPods';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import pendingGroupIdShipments from '../../common/pendingGroupIdShipments';
import Paginate from 'vuejs-paginate';
import AllocationTableTemplate from '../../common/AllocationTable';
import {
    getHubDeliverySRListByHubID as getHubDeliverySRListByHubID,
    GetHubFlags1 as GetHubFlags2,
    GetShipmentTableDetails as GetShipmentTableDetails,
    bulkDeallocationforrvp as bulkDeallocationforrvp,
    SeqofNonAllocation as GetNonAllocationSEQ,
    getAllReversePendingPriorityShipments as getAllReversePendingPriorityShipments,
    ShipmentConfirm as ConfirmShipment,
    TriDetails as GetTripdetails,
    StoreCantAllocatedShipment as StoreCantAllocatedShipment
} from '../../../../../services/modules/newallocationservices.js';
import { EventBus } from '../../../../main.js';



import {
    BasicSelect
} from "vue-search-select";
export default {
    name: "FWDAllocation",
    components: {
        Paginate,
        VueElementLoading,
        DatePicker,
        "load-table-template": tableTemplate,
        BasicSelect,
        'pending-Pods': pendingPods,
        "Allocation-Popup": AllocationPopup,
        'pending-group-id-shipment': pendingGroupIdShipments,
        'load-allocation-table-template': AllocationTableTemplate
    },
    mixins: [PageTracker],
    props: {
        srList: Array
    },
    data: function() {
        return {
            selectAll: false,
            value: false,
            CourierCompanyID: '',
            isRSVSr: 0,
            MobileNumber: '',
            OldUserid: '',
            SRSelectingloader: false,
            srArrayList: [],
            // srList: [],
            SrId: '',
            SrName: '',
            srItemObj: {
                value: "",
                text: ""
            },
            srLoader: '',
            loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
            showUnallocatedList: [],
            AllocatedList: [],
            isShowPendingAllocatedList: true,
            setDashboardCountTabNameType: 'pending',
            setCountSR: 0,
            setCountSVC: 0,
            srBlockFlag: true,
            svcBlockFlag: false,

            //Allocated
            setCountSRAllocated: 0,
            setCountSVCAllocated: 0,
            srAllocatedBlockFlag: false,
            svcAllocatedBlockFlag: false,
            //Counts Pending Sr
            setSRCountAll: 0,
            setSRCountP0: 0,
            setSRCountP1: 0,
            setSRCountP2: 0,
            setSRCountSame_route: 0,

            //Counts Allocated Sr
            setSRAllocatedCountAll: 0,
            setSRAllocatedCountP0: 0,
            setSRAllocatedCountP1: 0,
            setSRAllocatedCountP2: 0,

            //Count Pending Hide Show flag for SR
            setSRCountAllFlag: false,
            setSRCountP0Flag: false,
            setSRCountP1Flag: false,
            setSRCountP2Flag: false,
            setSRCountSame_routeFlag: true,

            //Count Allocated Hide Show flag for SR
            setSRAllocatedCountAllFlag: false,
            setSRAllocatedCountP0Flag: false,
            setSRAllocatedCountP1Flag: false,
            setSRAllocatedCountP2Flag: false,
            setSRAllocatedCountSame_routeFlag: false,

            //List Pending Sr
            setSRListAll: [],
            setSRListP0: [],
            setSRListP1: [],
            setSRListP2: [],
            setSRListSame_route: [],
            //List Allocated Sr List
            setSRAllocatedListAll: [],
            setSRAllocatedListP0: [],
            setSRAllocatedListP1: [],
            setSRAllocatedListP2: [],
            setSRAllocatedListSame_route: [],
            //Count Pending SVC
            setSVCCountAll: 0,
            setSVCCountP0: 0,
            setSVCCountP1: 0,
            setSVCCountP2: 0,
            setSVCCountSame_route: 0,

            //Count Allocated SVC
            setSVCAllocatedCountAll: 0,
            setSVCAllocatedCountP0: 0,
            setSVCAllocatedCountP1: 0,
            setSVCAllocatedCountP2: 0,
            setSVCAllocatedCountSame_route: 0,

            //List Pending SVC
            setSVCListAll: [],
            setSVCListP0: [],
            setSVCListP1: [],
            setSVCListP2: [],
            setSVCListSame_route: [],
            //List Allocated SVC
            setSVCAllocatedListAll: [],
            setSVCAllocatedListP0: [],
            setSVCAllocatedListP1: [],
            setSVCAllocatedListP2: [],
            setSVCAllocatedListSame_route: [],

            //Count Pending Hide Show flag for SVC
            setSVCCountAllFlag: false,
            setSVCCountP0Flag: false,
            setSVCCountP1Flag: false,
            setSVCCountP2Flag: false,
            setSVCCountSame_routeFlag: false,

            //Count Allocated Hide Show flag for SVC
            setSVCAllocatedCountAllFlag: false,
            setSVCAllocatedCountP0Flag: false,
            setSVCAllocatedCountP1Flag: false,
            setSVCAllocatedCountP2Flag: false,
            setSVCAllocatedCountSame_routeFlag: false,
            //active tab show flag for Pending
            activeTabSR: "light",
            activeTabSVC: 'outline-primary',
            //active tab show flag for Allocated
            activeTabSRAllocated: "light",
            activeTabSVCAllocated: 'outline-primary',

            //highlight active button flag pending SR
            activeTabSRAllFlag: 'outline-primary',
            activeTabSRP0Flag: 'outline-primary',
            activeTabSRP1Flag: 'outline-primary',
            activeTabSRP2Flag: 'outline-primary',
            activeTabSRSameRouteFlag: 'outline-primary',

            //highlight active button flag pending SVC
            activeTabSVCAllFlag: 'outline-primary',
            activeTabSVCP0Flag: 'outline-primary',
            activeTabSVCP1Flag: 'outline-primary',
            activeTabSVCP2Flag: 'outline-primary',
            activeTabSVCSameRouteFlag: 'outline-primary',

            //Search Pending Shipment
            searchPendingShipment: '',
            showRVPPendingShipmentsList: [],

            PendingRVPTable: '',
            PendingColumns: [
                { key: 'CustomerAddress', label: 'Pickup Address', type: 'text', size: 'min-width: 150px; white-space: normal; word-wrap: break-word;' },
                { key: 'ShipPincode', label: 'Pincode', type: 'text', size: 'min-width: 50px;' },
                { key: 'ClientName', label: 'Client Name', type: 'text', size: 'min-width: 100px;' },
                { key: ['ShippingID', 'MultiShipmentGroupID', 'NoOfMultiShipmentGroupId'], label: 'AWB|MPS', type: 'text', size: 'min-width: 150px;' },
                { key: 'CustomerName', label: 'Customer Name', type: 'text', size: 'min-width: 150px;' },
                { key: 'TotalAttemptCount', label: 'Reattempt', type: 'text', size: 'min-width: 150px;' },
                { key: 'PendingSince', label: 'Pending Days', type: 'text', size: 'min-width: 150px;' },
                { key: 'ReAttemptDate', label: 'Future Pick Date', type: 'text', size: 'min-width: 150px;' },
                { key: 'AssignDate', label: 'Pick Assign Date', type: 'text', size: 'min-width: 70px;' },
                { key: 'DeliveryUserName', label: 'Delivery User', type: 'text' },
            ],
            Shipmentloader: false,
            /* Select Checkbox Param */
            selectedItemsOnChild: [],
            selectAllCheckbox: false,
            IsCheckbox: true,
            checkboxDisabled: true,

            /* Local email store Param */
            localusermailid: '',

            /* Heavies Model Param */
            BucketName: '',
            TitleName: '',
            heaviesTitleName1: '',
            heaviesTitleName2: '',
            SEQShippingids: [],
            NonAllocationRsn: false,
            SeqArray: [],

            /* Confirm Allocation Param */
            allocationSuccessMsg: '',
            showParentGroupIdShipmentList: [],
            tripState: '',
            srVehicleNo: '',
            vehicleOpenKM: '',
            fromList: [{ value: "UA", text: "From Mobile" }, { value: "Web", text: "From Web" }],
            fromItemObj: { value: "UA", text: "From Mobile" },
            fromId: "UA",
            isVehicleReplaced: false,
            vehicleVendorId: '',
            vehicleType: '',
            srVehicleList: [],
            errorRvpAllocation: "",
            successRvpAllocation: '',
            errorRvpAllocationErrorArrobj: [],
            EmpType: '',
            CourierCompanyID: '',
            IsSRNeedTrip: '',

            /* Rever Priority Shipments */
            nonAlloationReasons: [],
            reversePendingShipments: [],
            RVPSPendingShipmentModelFlag: false,

            /* Un- Allcated Model param */
            startModelUnallocate: false,
            RVPPendingCountP0: 0,
            RVPPendingCountP1: 0,
            RVPPendingCountP0Array: [],
            RVPPendingCountP1Array: [],


            /* MPS Unallocate Model Param */
            MPSTitle: "",
            MPSSrNameTitle: "",
            MPSNote: "",
            MPSRows: "",
            MPSSelectedRow: "",
            startModelUnallocate: false,
            MPSAddress: '',
            MPSCount: '',
            MPSActionType: '',

            /* Can't Allocate Priority Shipment Param */
            RVPSCantAllcatePriorityShipmentModelFlag: false,
            RVPSCantPendingTitle: "",
            cantAllocatedchangeStatus: '',

            /* Deallocation Shipments */
            batchSize: 10, // Batch size

            /* Close model */
            openKM : '',
            openKmImg : '',
            closeKmImg : '',
            originCloseImg : '',
            tripId : '',
            srVehicleNo : '',
            openKm : '',
            closeTripModel : false
        };
    },
    filters: {
        batchCreatedDateFormat: function(date) {
            if (date == null) return ''
            return moment(date).format('DD-MM-YYYY');
        }
    },
    computed: {
        filteredTableData() {
            if (this.searchPendingShipment.trim() === '') {
                return this.showUnallocatedListFilter = [...this.showUnallocatedList];
            }
            return this.showUnallocatedListFilter = this.showUnallocatedList.filter(item =>
                item.ShippingID.toLowerCase().includes(this.searchPendingShipment.toLowerCase()) ||
                item.PickupCity.toLowerCase().includes(this.searchPendingShipment.toLowerCase()) ||
                item.CustomerAddress.toLowerCase().includes(this.searchPendingShipment.toLowerCase()) ||
                item.ShipPincode.toLowerCase().includes(this.searchPendingShipment.toLowerCase())
            );
        }
    },
    created() {
        EventBus.$off('referseFirstPanel', this.CommonGetTableDetails);
        EventBus.$on('referseFirstPanel', this.CommonGetTableDetails);
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        var userdetailEncrypt = window.localStorage.getItem("lmaccessuserdata");
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.createdBy = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0];
        this.localusermailid = userdetail.email;
        

        let vm = this;
        Promise.all([
                this.GetHubFlags(vm.userHubId),
                this.CommonGetTableDetails(),
                // this.GetDeliverySRList(vm.userHubId),
            ])
            .then((promresult) => {
                console.log('promresult ->', promresult);
            })
            .catch((err) => {
                console.log('error in page load functions', err);
            })

        const IsRVPPaperlessEncrypt = window.localStorage.getItem('IsRVPPaperless')
        const IsRVPPaperlessbytes = CryptoJS.AES.decrypt(IsRVPPaperlessEncrypt.toString(), this.userDataKey);
        const IsRVPPaperlessbytestext = IsRVPPaperlessbytes.toString(CryptoJS.enc.Utf8);
        const paperLessKey = JSON.parse(IsRVPPaperlessbytestext)

        if (paperLessKey != null && paperLessKey.trim() == "1") {
            this.IsRVPPaperless = true;
            this.deliveryOptionListPrint.splice(2, 1);
        } else {
            this.IsRVPPaperless = false;
        }
    },
    methods: {
        // GetDeliverySRList(hubid) {
        //     return new Promise((resolve, reject) => {
        //         try {
        //             this.srLoader = this.loader;
        //             this.srArrayList = [];
        //             this.srList = [];
        //             let RVPPayload = {
        //                 "usertype": "3",
        //                 "hubid": [hubid]
        //             }
        //             getHubDeliverySRListByHubID(RVPPayload, (result) => {
        //                 try {
        //                     this.srArrayList = result.data.data.results;
        //                     for (var i = 0; i < this.srArrayList.length; i++) {
        //                         this.srList.push({
        //                             value: this.srArrayList[i].userid,
        //                             text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
        //                             OldUserid: this.srArrayList[i].OldDeliveryUserOrUserId,
        //                             EmpType: this.srArrayList[i].EmpType,
        //                             CourierCompanyID: this.srArrayList[i].CourierCompanyID,
        //                             MobileNumber: this.srArrayList[i].MobileNumber,
        //                             IsSRNeedTrip: this.srArrayList[i].isTripAllowedForSR
        //                         })
        //                     }
        //                     this.srLoader = '';
        //                 } catch (e) {
        //                     console.log('Error------', e);
        //                 }
        //             })
        //             resolve(true);
        //         } catch (err) {
        //             console.log('Error Logs For GetDeliverySRList', err);
        //             resolve(false);
        //         }
        //     })
        // },
        GetHubFlags() {
            return new Promise((resolve, reject) => {
                try {
                    let HubFlagsRVPPayload = {
                        "Outsourceid": 4,
                        "hubid": this.userHubId
                    }
                    GetHubFlags2(HubFlagsRVPPayload, (result) => {
                        if (result.data.data.code == 200) {
                            this.isRSVSr = result.data.data.data.IsRSVSr
                        } else {
                            this.$alertify.error(result.data.data.message)
                        }
                    })
                    resolve(true)
                } catch (e) {
                    console.log('error logs..', e);
                    resolve(true)
                }
            })
        },
        CommonGetTableDetails() {
            // EventBus.$off("referseFirstPanel");
            this.CountLoading = true;
            let RVPPayload = {
                "hubId": parseInt(this.userHubId),
                "type": "allocated",
                "shipmentType": "RVP"
            }
            if (this.SrId) {
                RVPPayload.srId = this.SrId
            }
            // if (this.BucketName) {
            //     RVPPayload.bucket = this.BucketName
            // }
            GetShipmentTableDetails(RVPPayload, (result) => {
                if (result.data.code == 200) {
                    this.CountLoading = false;
                    this.showUnallocatedList = [];
                    this.showAllocatedShipmentsList = [];
                    //Pending SR list & count Reset.
                    this.setSRListAll = this.setSRListP0 = this.setSRListP1 = this.setSRListP2 = [];
                    this.setSRCountAll = this.setSRCountP0 = this.setSRCountP1 = this.setSRCountP2 = 0;
                    // Pending SVC list & count Reset.
                    this.setSVCListAll = this.setSVCListP0 = this.setSVCListP1 = this.setSVCListP2 = [];
                    this.setSVCCountAll = this.setSVCCountP0 = this.setSVCCountP1 = this.setSVCCountP2 = 0;

                    if (this.setDashboardCountTabNameType == 'pending') {
                        let finalResult = result.data.data;
                        this.setCountSR = finalResult.sr.count;
                        this.setCountSVC = finalResult.svc.count;
                        if (!finalResult.sr.list && this.SrId) {
                            this.srBlockFlag = true;
                            this.svcBlockFlag = false;
                            this.activeTabSR = 'primary';
                            this.activeTabSVC = 'outline-primary';
                            this.setSRCountP0 = (finalResult.sr.list.P0) ? finalResult.sr.list.P0.length : this.setSRCountP0;
                            this.setSRCountP1 = (finalResult.sr.list.P1) ? finalResult.sr.list.P1.length : this.setSRCountP1;
                            this.setSRCountP2 = (finalResult.sr.list.P2) ? finalResult.sr.list.P2.length : this.setSRCountP2;
                            this.setSRCountAll = parseInt(this.setSRCountP0) + parseInt(this.setSRCountP1) + parseInt(this.setSRCountP2)
                            this.setSRCountP0Flag = (this.setSRCountP0 > 0) ? true : false;
                            this.setSRCountP1Flag = (this.setSRCountP1 > 0) ? true : false;
                            this.setSRCountP2Flag = (this.setSRCountP2 > 0) ? true : false;
                            this.setSRCountAllFlag = (this.setSRCountAll > 0) ? true : false;
                            this.setSRListAll = []
                            this.setSRListP0 = []
                            this.setSRListP1 = []
                            this.setSRListP2 = []
                        }
                        if (finalResult.sr.list) {
                            this.srBlockFlag = true;
                            this.svcBlockFlag = false;
                            this.activeTabSR = 'primary';
                            this.activeTabSVC = 'outline-primary';
                            this.setSRCountP0 = (finalResult.sr.list.P0) ? finalResult.sr.list.P0.length : this.setSRCountP0;
                            this.setSRCountP1 = (finalResult.sr.list.P1) ? finalResult.sr.list.P1.length : this.setSRCountP1;
                            this.setSRCountP2 = (finalResult.sr.list.P2) ? finalResult.sr.list.P2.length : this.setSRCountP2;
                            this.setSRCountAll = parseInt(this.setSRCountP0) + parseInt(this.setSRCountP1) + parseInt(this.setSRCountP2)

                            //Show hide flag
                            this.setSRCountP0Flag = (this.setSRCountP0 > 0) ? true : false;
                            this.setSRCountP1Flag = (this.setSRCountP1 > 0) ? true : false;
                            this.setSRCountP2Flag = (this.setSRCountP2 > 0) ? true : false;
                            this.setSRCountAllFlag = (this.setSRCountAll > 0) ? true : false;

                            //SR pending list
                            if (finalResult.sr.list.P0) {
                                this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P0]
                                this.setSRListP0 = [...this.setSRListP0, ...finalResult.sr.list.P0]
                            }
                            if (finalResult.sr.list.P1) {
                                this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P1]
                                this.setSRListP1 = [...this.setSRListP1, ...finalResult.sr.list.P1]
                            }
                            if (finalResult.sr.list.P2) {
                                this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P2]
                                this.setSRListP2 = [...this.setSRListP2, ...finalResult.sr.list.P2]
                            }

                        }

                        if (finalResult.svc.list) {
                            this.srBlockFlag = false;
                            this.svcBlockFlag = true;
                            this.activeTabSVC = 'primary';
                            this.activeTabSR = 'outline-primary';


                            const { P0, P1, P2 } = finalResult.svc.list;

                            // Set SVC counts and flags
                            this.setSVCCountP0 = P0 ? P0.length : this.setSVCCountP0;
                            this.setSVCCountP1 = P1 ? P1.length : this.setSVCCountP1;
                            this.setSVCCountP2 = P2 ? P2.length : this.setSVCCountP2;
                            this.setSVCCountAll = parseInt(this.setSVCCountP0) + parseInt(this.setSVCCountP1) + parseInt(this.setSVCCountP2);

                            //Show hide flag
                            this.setSVCCountP0Flag = (this.setSVCCountP0 > 0) ? true : false;
                            this.setSVCCountP1Flag = (this.setSVCCountP1 > 0) ? true : false;
                            this.setSVCCountP2Flag = (this.setSVCCountP2 > 0) ? true : false;
                            this.setSVCCountAllFlag = (this.setSVCCountAll > 0) ? true : false;

                            //SVC pending List
                            if (finalResult.svc.list.P0) {
                                this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P0]
                                this.setSVCListP0 = [...this.setSVCListP0, ...finalResult.svc.list.P0]
                            }
                            if (finalResult.svc.list.P1) {
                                this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P1]
                                this.setSVCListP1 = [...this.setSVCListP1, ...finalResult.svc.list.P1]
                            }
                            if (finalResult.svc.list.P2) {
                                this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P2]
                                this.setSVCListP2 = [...this.setSVCListP2, ...finalResult.svc.list.P2]
                            }

                        }

                        if (finalResult.sr.list) {
                            this.changeSelected('pendingsr', 'All')
                        } else if (finalResult.svc.list) {
                            this.changeSelected('pendingsvc', 'All')
                        }
                    }
                } else if (result.data.code != 200) {
                    this.CountLoading = false;
                    this.showUnallocatedList = [];
                    console.log('No Shipments found..');
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
                }

            })
        },
        changeSelected(params, subparams) {

            this.showUnallocatedList = [];
            this.showAllocatedShipmentsList = [];
            if (params == 'pendingsr') {
                this.srBlockFlag = true;
                this.svcBlockFlag = false;
                this.activeTabSR = 'primary';
                this.activeTabSVC = 'outline-primary';

                //Show hide flag
                this.setSRCountP0Flag = (this.setSRCountP0 > 0) ? true : false;
                this.setSRCountP1Flag = (this.setSRCountP1 > 0) ? true : false;
                this.setSRCountP2Flag = (this.setSRCountP2 > 0) ? true : false;
                this.setSRCountAllFlag = (this.setSRCountAll > 0) ? true : false;

                //Show all shipment Pending SR
                if (subparams == 'All') {
                    this.activeTabSRAllFlag = (subparams == 'All') ? 'primary' : 'outline-primary';
                    this.activeTabSRP0Flag = this.activeTabSRP1Flag = this.activeTabSRP2Flag = this.activeTabSRSameRouteFlag = 'outline-primary'
                    this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListAll);
                } else if (subparams == 'P0') {
                    this.activeTabSRP0Flag = (subparams == 'P0') ? 'primary' : 'outline-primary';
                    this.activeTabSRAllFlag = this.activeTabSRP1Flag = this.activeTabSRP2Flag = this.activeTabSRSameRouteFlag = 'outline-primary'
                    this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP0);
                } else if (subparams == 'P1') {
                    this.activeTabSRP1Flag = (subparams == 'P1') ? 'primary' : 'outline-primary';
                    this.activeTabSRAllFlag = this.activeTabSRP0Flag = this.activeTabSRP2Flag = this.activeTabSRSameRouteFlag = 'outline-primary'
                    this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP1);
                } else if (subparams == 'P2') {
                    this.activeTabSRP2Flag = (subparams == 'P2') ? 'primary' : 'outline-primary';
                    this.activeTabSRAllFlag = this.activeTabSRP0Flag = this.activeTabSRP1Flag = this.activeTabSRSameRouteFlag = 'outline-primary'
                    this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP2);
                }
            } else if (params == 'pendingsvc') {
                this.srBlockFlag = false;
                this.svcBlockFlag = true;
                this.activeTabSVC = 'primary';
                this.activeTabSR = 'outline-primary';

                //Show hide flag
                this.setSVCCountP0Flag = (this.setSVCCountP0 > 0) ? true : false;
                this.setSVCCountP1Flag = (this.setSVCCountP1 > 0) ? true : false;
                this.setSVCCountP2Flag = (this.setSVCCountP2 > 0) ? true : false;
                this.setSVCCountAllFlag = (this.setSVCCountAll > 0) ? true : false;
                this.setSVCCountSame_routeFlag = (this.setSVCCountSame_route > 0) ? true : false;

                //Show all shipment Pending SVC
                if (subparams == 'All') {
                    this.activeTabSVCAllFlag = (subparams == 'All') ? 'primary' : 'outline-primary';
                    this.activeTabSVCP0Flag = this.activeTabSVCP1Flag = this.activeTabSVCP2Flag = this.activeTabSVCSameRouteFlag = 'outline-primary'
                    this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListAll);
                } else if (subparams == 'P0') {
                    this.activeTabSVCP0Flag = (subparams == 'P0') ? 'primary' : 'outline-primary';
                    this.activeTabSVCAllFlag = this.activeTabSVCP1Flag = this.activeTabSVCP2Flag = this.activeTabSVCSameRouteFlag = 'outline-primary'
                    this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP0);
                } else if (subparams == 'P1') {
                    this.activeTabSVCP1Flag = (subparams == 'P1') ? 'primary' : 'outline-primary';
                    this.activeTabSVCAllFlag = this.activeTabSVCP0Flag = this.activeTabSVCP2Flag = this.activeTabSVCSameRouteFlag = 'outline-primary'
                    this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP1);
                } else if (subparams == 'P2') {
                    this.activeTabSVCP2Flag = (subparams == 'P2') ? 'primary' : 'outline-primary';
                    this.activeTabSVCAllFlag = this.activeTabSVCP0Flag = this.activeTabSVCP1Flag = this.activeTabSVCSameRouteFlag = 'outline-primary'
                    this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP2);
                }
            }

            this.showUnallocatedListFilter = [...this.showUnallocatedList];
        },
        selectSR(obj) {
            this.srItemObj = {};
            this.SrId = '';
            this.SrName = '';

            // Reset counts and lists for SR
            this.setSRListAll = [];
            this.setSRListP0 = [];
            this.setSRListP1 = [];
            this.setSRListP2 = [];
            this.setSRCountAll = this.setSRCountP0 = this.setSRCountP1 = this.setSRCountP2 = 0;


            // Set the selected SR
            this.srItemObj = obj;
            this.SrId = obj.value;
            this.SrName = obj.text;
            this.OldUserid = obj.OldUserid;
            this.EmpType = obj.EmpType;
            this.CourierCompanyID = obj.CourierCompanyID;
            this.MobileNumber = obj.MobileNumber;
            this.IsSRNeedTrip = obj.IsSRNeedTrip;
            // isTripAllowedForSR
            // Set flags for tab display
            this.srBlockFlag = false;
            this.svcBlockFlag = true;
            this.activeTabSVC = 'primary';
            this.activeTabSR = 'outline-primary';

            this.resetSVCButtonColors()

            // Show/hide flags based on the new SR counts
            this.setSRCountP0Flag = this.setSRCountP0 > 0;
            this.setSRCountP1Flag = this.setSRCountP1 > 0;
            this.setSRCountP2Flag = this.setSRCountP2 > 0;
            this.setSRCountAllFlag = this.setSRCountAll > 0;

            //Clear Selected shipment
            this.selectedItemsOnChild = [];

            // Fetch the new SR details
            this.CommonGetTableDetails();
        },
        clearSR() {
            EventBus.$off('refreshSecondPanel');
            this.SrId = '';
            this.srItemObj = {};
            this.tripDayflag = 0;
            this.tripTitle = '';
            this.tripCreatedDate = '';
            this.searchPendingShipment = '';
            this.filteredTableData = [];
            this.PendingRVPTable = [];
            this.showUnallocatedListFilter = this.showUnallocatedList;

            this.srBlockFlag = true;
            this.svcBlockFlag = false;

            this.setSVCCountAllFlag = false;
            this.setSVCCountP0Flag = false;
            this.setSVCCountP1Flag = false;
            this.setSVCCountP2Flag = false;

            this.setSVCAllocatedCountAllFlag = false;
            this.setSVCAllocatedCountP0Flag = false;
            this.setSVCAllocatedCountP1Flag = false;
            this.setSVCAllocatedCountP2Flag = false;


            this.activeTabSR = 'outline-primary';
            this.activeTabSVC = 'outline-primary';

            this.activeTabSRAllocated = 'outline-primary';
            this.activeTabSVCAllocated = 'outline-primary';
            this.selectAllCheckbox = false;
            this.selectedItemsOnChild = [];
            this.resetSRButtonColors()

            this.resetSVCButtonColors()

            this.CommonGetTableDetails()
        },

        updateSRAllocatedFlags() {
            this.setSRAllocatedCountP0Flag = this.setSRAllocatedCountP0 > 0;
            this.setSRAllocatedCountP1Flag = this.setSRAllocatedCountP1 > 0;
            this.setSRAllocatedCountP2Flag = this.setSRAllocatedCountP2 > 0;
            this.setSRAllocatedCountAllFlag = this.setSRAllocatedCountAll > 0;
        },

        updateSVCAllocatedFlags() {
            this.setSVCAllocatedCountP0Flag = this.setSVCAllocatedCountP0 > 0;
            this.setSVCAllocatedCountP1Flag = this.setSVCAllocatedCountP1 > 0;
            this.setSVCAllocatedCountP2Flag = this.setSVCAllocatedCountP2 > 0;
            this.setSVCAllocatedCountAllFlag = this.setSVCAllocatedCountAll > 0;
        },

        resetSVCButtonColors() {
            this.activeTabSVCAllFlag = 'outline-primary'
            this.activeTabSVCP0Flag = 'outline-primary'
            this.activeTabSVCP1Flag = 'outline-primary'
            this.activeTabSVCP2Flag = 'outline-primary'
            this.activeTabSVCSameRouteFlag = 'outline-primary'
        },

        resetSRButtonColors() {
            this.activeTabSRAllFlag = 'outline-primary'
            this.activeTabSRP0Flag = 'outline-primary'
            this.activeTabSRP1Flag = 'outline-primary'
            this.activeTabSRP2Flag = 'outline-primary'
            this.activeTabSRSameRouteFlag = 'outline-primary'
        },
        /* DeAllocate Shipment */
        async processShipments() {
            this.CountLoading = true;
            try {
                let Test = true;
                for (let i = 0; i < this.selectedItemsOnChild.length; i += this.batchSize) {
                    const batch = this.selectedItemsOnChild.slice(i, i + this.batchSize);

                    const success = await this.rvpShipmentDeallocation(batch);

                    if (!success.type) {
                        this.$alertify.error(success.message + " - " + batch.map(s => s.ShippingID).join(', '));
                        Test = false;
                        break;
                    }
                }

                if (Test) {
                    this.selectedItemsOnChild = [];
                    EventBus.$emit('referseFirstPanel');
                    this.clearSR();
                    this.$alertify.success("Shipment(s) has been de-allocated successfully");
                }
            } catch (error) {
                this.$alertify.error(error);
                console.error(error);
            } finally {
                this.CountLoading = false;
            }
        },
        /* Deallocate Shipping id */
        rvpShipmentDeallocation(batch) {
            return new Promise((resolve) => {
                let RVPDeallocationPayload = {
                    "shipmentType": "RVP",
                    "lastModifiedBy": this.localusermailid
                }
                if (batch.length > 0) {
                    RVPDeallocationPayload.shippingIds = batch.map(obj => obj.ShippingID);
                }
                bulkDeallocationforrvp(RVPDeallocationPayload, (result) => {
                    if (result.data.code == 200) {
                        resolve({ 'type': true, 'message': result.data.message })
                    } else if (result.data.code != 200) {
                        resolve({ 'type': false, 'message': result.data.message })
                    }
                })
            });
        },
        SubmitHeavies() {
            this.CloseNonAllocationRsn();
            this.getReversePriorityShipments();
        },
        CloseNonAllocationRsn() {
            this.BucketName = '';
            this.TitleName = '';
            this.heaviesTitleName1 = '';
            this.heaviesTitleName2 = '';
            this.SEQShippingids = [];
            this.NonAllocationRsn = false;
            this.SeqArray = [];
        },
        async CheckPDD() {
            this.CountLoading = true;
            if ([614, 3586, 3550].includes(this.userHubId)) {
                this.CloseNonAllocationRsn()
                let Payload = {
                    "DeliveryUserId": this.SrId,
                    "HubId": this.userHubId.toString(),
                    "shipmenttype": "RVP",
                }
                await GetNonAllocationSEQ(Payload, (result) => {
                    if (result.data.code == 200 && result.data.data.length > 0) {
                        this.SeqArray = result.data.data.filter(x => (x.result));
                        this.BucketName = this.SeqArray[0].Bucket;
                        this.TitleName = this.SeqArray[0].title;
                        if (this.BucketName == 'Heavies') {
                            this.CountLoading = false;
                            let splitStringArray = this.TitleName.split('_');
                            this.heaviesTitleName1 = splitStringArray[0];
                            this.heaviesTitleName2 = splitStringArray[1];
                            this.SEQShippingids = this.SeqArray[0].shippingids;
                            this.NonAllocationRsn = true;
                        } else {
                            this.CountLoading = false;
                            this.CloseNonAllocationRsn();
                            this.getReversePriorityShipments();
                        }
                    } else {
                        this.CountLoading = false;
                        this.CloseNonAllocationRsn();
                        this.getReversePriorityShipments();
                    }
                })
            } else {
                this.CountLoading = false;
                this.CloseNonAllocationRsn();
                this.getReversePriorityShipments();
            }
        },
        refreshData() {
            this.clearSR()
        },
        getSrTripdetails() {
            return new Promise((resolve, reject) => {
                let TripDetailsRVPPayload = {
                    "XBkey": "XB123",
                    "HubId": this.userHubId,
                    "DeliveryUserId": this.SrId
                }
                GetTripdetails(TripDetailsRVPPayload, (result) => {
                    if (result.data.TripState =="deliveryuserclosed" && result.data.code == 200) {

                        this.tripState = result.data.TripState;
                        this.vehicleOpenKM = result.data.OpenKM;
                        this.VehicleNo = result.data.VehicleNo;
                        return resolve(result.data)
                    } else {
                        return resolve(false)
                    }
                }, error => {
                    console.error(error)
                })
            })
        },
        closeCloseTripModel() {
            this.closeTripModel = false
        },
        RefreshShipment() {
            this.clearSR()
        },
        CloseModelMPS(selectedValue, row, type) {

            if (type == 'checker') {
                this.selectedItemsOnChild.pop(row);
            }
            if (type == 'checkerRemove') {
                this.selectedItemsOnChild.push(row);
            }
            this.MPSTitle = "";
            this.MPSSrNameTitle = "";
            this.MPSNote = "";
            this.MPSRows = "";
            this.MPSSelectedRow = "";
            this.startModelUnallocate = false;
            this.MPSAddress = '';
            this.MPSCount = '';
            this.MPSActionType = '';
        },
        selectAllItems(ev) {
            this.selectedItemsOnChild = [];
            if (ev.target.checked == true) {
                for (let i in this.showUnallocatedListFilter) {
                    this.selectedItemsOnChild.push(this.showUnallocatedListFilter[i]);
                }
            } else {
                for (let i in this.showUnallocatedListFilter) {
                    this.selectedItemsOnChild.pop(this.showUnallocatedListFilter[i]);
                }
            }

            if (this.showUnallocatedListFilter.length <= 1) {
                for (let i in this.showUnallocatedListFilter) {
                    this.selectedItemsOnChild.push(this.showUnallocatedListFilter[i]);
                }
                for (let i in this.showUnallocatedListFilter) {
                    this.selectedItemsOnChild.pop(this.showUnallocatedListFilter[i]);
                }
            }
            // this.selectedItemdata(ev);
        },
        selectedItemdata($event, row) {
            if ($event.target.checked) {
                row.checker = true;
                const matchingRecords = this.showUnallocatedListFilter.filter(record => record.CustomerAddress === row.CustomerAddress).length;
                //Add new param for Select box
                if (matchingRecords > 1) {
                    //Open MPS POPup
                    this.MPSTitle = "Same Address / MPS Shipment";
                    this.MPSSrNameTitle = "";
                    this.MPSNote = `All the shipments with the same address and/or MPS shipments corresponding to selected shipment will get de-allocated`;
                    this.MPSAddress = `Address:- ${row.CustomerAddress}.`;
                    this.MPSCount = `Shipment count: ${matchingRecords}`;
                    this.MPSRows = row;
                    this.MPSSelectedRow = "";
                    this.startModelUnallocate = true;
                    this.MPSActionType = 'checker';
                    /* END */
                }
            } else {
                const matchingRecords = this.showUnallocatedListFilter.filter(record => record.CustomerAddress === row.CustomerAddress).length;
                //Add new param for Select box
                if (matchingRecords > 1) {
                    //Open MPS POPup
                    this.MPSTitle = "Same Address / MPS Shipment";
                    this.MPSSrNameTitle = "";
                    this.MPSNote = `will be selected for the same address and/or MPS shipments.`;
                    this.MPSAddress = `Address:- ${row.CustomerAddress}.`;
                    this.MPSCount = `Shipment count: ${matchingRecords}`;
                    this.MPSRows = row;
                    this.MPSSelectedRow = "";
                    this.startModelUnallocate = true; /* Showing MPSGroupID Popup */
                    this.MPSActionType = 'checkerRemove';
                    /* END */
                }
            }
            if (this.selectedItemsOnChild.length == 0) {
                this.selectAllCheckbox = false;
            }
            if (this.selectedItemsOnChild.length <= (this.showUnallocatedListFilter.length - 1)) {
                this.selectAllCheckbox = false
            }
            if (this.selectedItemsOnChild.length == this.showUnallocatedListFilter.length) {
                this.selectAllCheckbox = true
            }
            if (this.showShipmentsList.length <= 1) {
                this.selectAllCheckbox = true;
                if (this.selectedItemsOnChild.length == 0) {
                    this.selectAllCheckbox = false
                }
            }
        },
        /* Get same address shipment need to checked */
        getSameMPSGroupShipmentsRVP2(selectedValue, row, type) {
            if (type == 'Add') {
                const matchingRecords = this.showUnallocatedListFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                //Add new param for Select box
                // Add a new key-value to each matching record
                matchingRecords.forEach(obj => {
                    obj.srItemObj = selectedValue; // Add new key
                    obj.SrId = selectedValue.value;
                    obj.SrName = selectedValue.text;
                    obj.OldDeliveryUserOrUserId = selectedValue.OldUserid;
                    obj.EmpType = selectedValue.EmpType;
                    obj.CourierCompanyID = selectedValue.CourierCompanyID;
                    obj.MobileNumber = selectedValue.MobileNumber;
                    obj.IsSRNeedTrip = selectedValue.IsSRNeedTrip;
                    obj.selectedUserID = true;
                });
                this.selectedCount = this.showUnallocatedListFilter.filter(obj => obj.selectedUserID == true).length;
            } else if (type == 'remove') {
                const matchingRecords = this.showUnallocatedListFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                //Add new param for Select box
                // Add a new key-value to each matching record
                matchingRecords.forEach(obj => {
                    obj.srItemObj = ''; // Add new key
                    obj.SrId = '';
                    obj.SrName = '';
                    obj.OldDeliveryUserOrUserId = '';
                    obj.EmpType = '';
                    obj.CourierCompanyID = '';
                    obj.MobileNumber = '';
                    obj.IsSRNeedTrip = '';
                    obj.selectedUserID = false;
                });
                this.selectedCount = this.showUnallocatedListFilter.filter(obj => obj.selectedUserID == true).length;
            } else if (type == 'checker') {
                const matchingRecords = this.showUnallocatedListFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                //Add new param for Select box
                // Add a new key-value to each matching record
                matchingRecords.forEach(obj => {
                    obj.checker = true;
                    const exists = this.selectedItemsOnChild.some(item => item.ShippingID === obj.ShippingID.toString());

                    // If not exists, push the object into the final array
                    if (!exists) {
                        this.selectedItemsOnChild.push(obj);
                    }
                });
            } else if (type == 'checkerRemove') {
                const matchingRecords = this.showUnallocatedListFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                //Add new param for Select box
                // Add a new key-value to each matching record
                matchingRecords.forEach(obj => {
                    obj.checker = false; // Add a new param to each matching record

                    // Find the index of the matching record in selectedItemsOnChild
                    const index = this.selectedItemsOnChild.findIndex(
                        item => item.ShippingID === obj.ShippingID.toString()
                    );

                    // If found, remove the object from the selectedItemsOnChild array
                    if (index !== -1) {
                        this.selectedItemsOnChild.splice(index, 1);
                    }
                });
            }
            this.CloseModelMPS();
        },

        /* Get All reverse Priority Shipment */
        getReversePriorityShipments() {
            let Payload = {
                "srId": this.SrId,
                "hubId": this.userHubId,
                "shipmentType": "RVP",
                "type": 'pending'
            }
            getAllReversePendingPriorityShipments(Payload, (result) => {
                if (result.data.code == 200 && result.data.data.length > 0) {
                    let RVPPendingShipments = result.data.data;
                    for (let index = 0; index < RVPPendingShipments.length; index++) {
                        const element = RVPPendingShipments[index];
                        if (element.lebal == 'P0') {
                            this.RVPPendingCountP0 = element.shipments.length;
                            this.RVPPendingCountP0Array = element.shipments;
                        }
                        if (element.lebal == 'P1') {
                            this.RVPPendingCountP1 = element.shipments.length;
                            this.RVPPendingCountP1Array = element.shipments;
                        }
                    }

                    // this.$emit("send-data", this.srItemObj);
                    this.RVPSPendingTitle = "Allocate All Priority Shipments"
                    this.reversePendingShipments = result.data.data;
                    this.nonAlloationReasons = result.data.data[0].nonAllocationReason;
                    this.RVPSPendingShipmentModelFlag = true;
                    this.CountLoading = false;
                } else {
                    this.confirmTrip();
                    this.CloseNonAllocationRsn();
                }

            })
        },

        /* View Reverse Priority pending shipment to left panel &&*/
        ViewRVPPendingShipments() {
            this.CountLoading = false;
            this.RVPSPendingTitle = "Allocate All Priority Shipments"
            this.reversePendingShipments = [];
            this.nonAlloationReasons = [];
            this.RVPSPendingShipmentModelFlag = false;
            this.RVPPendingCountP0 = 0;
            this.RVPPendingCountP0Array = [];
            this.RVPPendingCountP1 = 0;
            this.RVPPendingCountP1Array = [];
            EventBus.$emit("send-data-sr", this.srItemObj);
            // this.clearSR();
        },

        /* Close RVP Priority shipment model and open can't allocated shipment model  */
        CloseRVPSPendingShipmentModelFlag() {
            this.RVPSPendingShipmentModelFlag = false;
            this.RVPSCantAllcatePriorityShipmentModelFlag = true;
            this.RVPSCantPendingTitle = "Can’t allocate priority shipments?";
        },

        /* Can't Allocated Priority shipment Model false */
        CloseRVPSCantAllcatePriorityShipmentModelFlag() {
            this.RVPSCantAllcatePriorityShipmentModelFlag = false;
            this.RVPSCantPendingTitle = "";
            this.clearSR();
        },

        /* Save Can't Allocate Priority Shipment Model  */
        saveCantAllocateShipment() {
            this.CountLoading = true;
            let data = [];
            if (this.RVPPendingCountP0Array.length > 0) {
                let P0Paylaod = {
                    "lebal": "P0",
                    "reasonCode": this.cantAllocatedchangeStatus.reasonCode,
                    "reasonText": this.cantAllocatedchangeStatus.reasonText,
                    "shipments": this.RVPPendingCountP0Array
                }
                data.push(P0Paylaod)
            }
            if (this.RVPPendingCountP1Array.length > 0) {
                let P1Paylaod = {
                    "lebal": "P1",
                    "reasonCode": this.cantAllocatedchangeStatus.reasonCode,
                    "reasonText": this.cantAllocatedchangeStatus.reasonText,
                    "shipments": this.RVPPendingCountP1Array
                }
                data.push(P1Paylaod)
            }

            let reqPayload = {
                "hubId": this.userHubId,
                "srId": this.SrId,
                "createdBy": this.createdBy,
                "data": data

            }

            StoreCantAllocatedShipment(reqPayload, (result) => {
                if (result.data.code == 200) {
                    this.CountLoading = false;
                    this.RVPSCantAllcatePriorityShipmentModelFlag = false;
                    this.$alertify.success(result.data.message);
                    this.confirmTrip()
                } else {
                    this.CountLoading = false;
                    this.$alertify.error(result.data.message);
                }
            });
        },
        async confirmTrip() {
           this.CountLoading = true;
            let verifyShipment = false
            if (this.IsSRNeedTrip) {
                verifyShipment = await this.getSrTripdetails();
            }
            if(verifyShipment == false) {
                this.allocationSuccessMsg = ''
                this.showParentGroupIdShipmentList = [];
                let RVPPayload = {
                    "XBkey": "XB123",
                    "sruserid": this.SrId.toString(),
                    "hubid": this.userHubId,
                    "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                    "tripstate": this.tripState, //"created",
                    "vehicleno": this.VehicleNo ? this.VehicleNo.toUpperCase() : '',
                    "vehicletype": this.vehicleType,
                    "triptype": "RVP",
                    "srname": this.SrName,
                    "isvehiclereplaced": this.isVehicleReplaced,
                    "LastModifiedBy": this.createdBy,
                    "MarkedFrom": this.fromId,
                    "operationType": "lastmile",
                    "isHandoverDeliveryUser": 1,
                    "allocationType":"RVP"
                }
                if ((this.vehicleType == 'bike' && this.srVehicleList.length == 0) || this.isVehicleReplaced == true) {
                    RVPPayload['isvehicleupdated'] = true
                } else {
                    RVPPayload['isvehicleupdated'] = false
                }
                if (this.vehicleType == 'vehicle') {
                    RVPPayload['vehiclevendorid'] = this.vehicleVendorId
                }
                ConfirmShipment(RVPPayload, (result) => {
                    if (result.data.code == 200) {
                        this.CountLoading = false;
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            userid: this.userid,
                            username: this.createdBy,
                            meta: {
                                "event": "confirmShipment",
                                "sruserid": this.SrId.toString(),
                                "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                                "triptype": "RVP",
                                "srname": this.SrName,
                                "isvehiclereplaced": this.isVehicleReplaced,
                                "MarkedFrom": this.fromId,
                            }
                        }
                        this.PageTracker(TrackerInfo);
                        this.$alertify.success(result.data.message)
                        this.fromId = "UA";
                        this.errorRvpAllocation = "";
                        this.successRvpAllocation = '';
                        this.errorRvpAllocationErrorArrobj = [];
                        this.clearSR();
                    } else {
                        if (result.data.status == 208) {
                            this.showGroupIdShipmentModel = true;
                            this.pendingGrouptErrorMsg = result.data.message;
                            this.showParentGroupIdShipmentList = result.data.data;
                        } else {
                            this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                        }
                    }
                    this.CountLoading = false;
                    EventBus.$emit('referseFirstPanel');
                }, error => {
                    console.error(error)
                    this.CountLoading = false;
                })
            }else{

                this.CountLoading = false;
                this.$alertify.error("Please close the Trip")
                // this.openKM = verifyShipment.OpenKM
                // this.openKmImg = verifyShipment.OpenKMImageUrl
                // this.closeKmImg = verifyShipment.CloseKMImagUrl
                // this.originCloseImg = verifyShipment.CloseKMImagUrl
                // this.tripId = verifyShipment.TripId
                // this.srVehicleNo = verifyShipment.VehicleNo
                // this.openKm = verifyShipment.OpenKM
                // this.closeTripModel = true
            }
        },
    },
};


// WEBPACK FOOTER //
// ./src/views/components/newallocationpagev2/ReverseConfirmAllocation/reverseconfirmallocation.js